exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".gameicon{height:100px;float:left;margin-right:10px}.title{font-size:1.4rem;font-weight:500;line-height:1.6rem}.descrition{font-size:1.3rem;font-weight:400;line-height:1.8rem}.game-list-row{margin:10px 0}.game-list-row a,.game-list-row a:hover{color:#212525;text-decoration:none}.game-list-row:after{content:\"\";display:block;clear:both}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7f7dca67","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ListGames.vue
// module id = 23
// module chunks = 0